import { Component, input } from '@angular/core';

import { QuestionnaireNotCompletedNotificationDto } from '../../../shared/models/models';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-questionnaire-not-completed-body',
    templateUrl: './questionnaire-not-completed-body.component.html',
    styleUrls: ['./questionnaire-not-completed-body.component.scss'],
    imports: [TranslatePipe],
})
export class QuestionnaireNotCompletedBodyComponent {
  notification = input.required<QuestionnaireNotCompletedNotificationDto>();
}
